import React, { memo, forwardRef } from "react";
const SvgSquarebrackets = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.2}
        d="M14.487 27.84h2.7c.283 0 .514-.064.674-.208.163-.146.236-.36.236-.621s-.073-.475-.236-.621c-.16-.145-.391-.208-.674-.208h-1.87V5.322h1.87c.283 0 .514-.063.674-.208.163-.146.236-.36.236-.621s-.073-.475-.236-.621c-.16-.145-.391-.208-.674-.208h-2.7c-.366 0-.66.092-.86.293-.201.2-.293.494-.293.86v21.87c0 .366.092.66.293.86.2.201.494.293.86.293z"
      />
    </svg>
  );
});
SvgSquarebrackets.displayName = "SvgSquarebrackets";
const MemoForwardRef = memo(SvgSquarebrackets);
export default MemoForwardRef;
